import { brand } from '@brand';

import { mix, parseHex } from './brandPalette';

/**
 * The bar across the top of the reveal page, in whichever brand this build wears.
 *
 * It was written out as hex, so a client's reveal page carried their logo on our blue — on the one
 * page whose whole point is that the person opening it has never heard of us.
 *
 * Our own builds declare no palette and get exactly the colours they had.
 */

const SHAREPASS = { from: '#1976D2', to: '#0052CC' };

const ends = (): { from: string; to: string } => {
    const primary = brand.palette?.primary;
    if (!primary || !parseHex(primary)) return SHAREPASS;
    return { from: mix(primary, '#FFFFFF', 0.12), to: mix(primary, '#000000', 0.18) };
};

export const HEADER_GRADIENT = (() => {
    const { from, to } = ends();
    return `linear-gradient(to right, ${from}, ${to})`;
})();
